import useLocalStorage from 'app/common/hooks/useLocalStorage';

const MOBILE_APP_BANNER_KEY = 'downloadMobileAppBanner';

export const useMobileAppBanner = () => {
    return useLocalStorage(MOBILE_APP_BANNER_KEY, true, {
        maxAge: 3 * 24 * 3600, // 3 Days
    });
};
